<template>
  <div class="container change">
    <div class="container__forms">
      <div class="form">
        <form action="" class="form__sign-in">
          <h2 class="form__title">Acceso por M&oacute;vil</h2>

          <div class="form__input-field">
            <i class="fas fa-user"></i>
            <input type="text" placeholder="Patente" v-model="plate" required />
          </div>
          <div class="form__input-field">
            <i class="fas fa-lock"></i>
            <input type="password" placeholder="Contraseña" v-model="password" required />
          </div>
          <input class="form__submit" type="submit" @click.prevent="login()" value="INGRESAR" />
          <p class="form__social-text">ICARO control y Gesti&oacute;n de Flota</p>
          <div class="form__social-media">
            <a href="#" class="form__social-icons">
              <i class="fab fa-facebook-f"></i>
            </a>
            <a href="#" class="form__social-icons">
              <i class="fab fa-twitter"></i>
            </a>
            <a href="#" class="form__social-icons">
              <i class="fab fa-google"></i>
            </a>
            <a href="#" class="form__social-icons">
              <i class="fab fa-linkedin-in"></i>
            </a>
          </div>
        </form>

        <form action="" class="form__sign-up">
          <h2 class="form__title">Acceso de Flota</h2>
          <div class="form__input-field">
            <i class="fas fa-user"></i>
            <InputRut v-model="plate"></InputRut>
          </div>
          <!-- <div class="form__input-field">
            <i class="fas fa-envelope"></i>
            <input type="text" placeholder="Email" required />
          </div> -->

          <div class="form__input-field">
            <i class="fas fa-lock"></i>
            <input type="password" placeholder="Contraseña" v-model="password" required />
          </div>

          <input class="form__submit" type="submit" @click.prevent="loginFlota()" value="INGRESAR" />

          <p class="form__social-text">ICARO control y Gesti&oacute;n de Flota</p>
          <div class="form__social-media">
            <a href="#" class="form__social-icons">
              <i class="fab fa-facebook-f"></i>
            </a>
            <a href="#" class="form__social-icons">
              <i class="fab fa-twitter"></i>
            </a>
            <a href="#" class="form__social-icons">
              <i class="fab fa-google"></i>
            </a>
            <a href="#" class="form__social-icons">
              <i class="fab fa-linkedin-in"></i>
            </a>
          </div>
        </form>
      </div>
    </div>
    <div class="container__panels">
      <div class="panel panel__left">
        <div class="panel__content">
          <h3 class="panel__title">Tienes m&aacute;s de un veh&iacute;culo?</h3>
          <p class="panel__paragraph">
           Ahora podr&aacute;s visualizar las producciones de tus veh&iacute;culos de una forma mas r&aacute;pida y c&oacute;moda, s&oacute;lo debes solicitar el acceso a la empresa
          </p>
          <button class="btn btn-transparent" id="sign-up-btn">
            ACCESO DE FLOTA
          </button>
        </div>
        <!-- <img class="panel__image" src="https://stories.freepiklabs.com/storage/11588/market-launch-amico-2628.png" alt="" /> -->
      </div>
      <div class="panel panel__right">
        <div class="panel__content">
          <h3 class="panel__title">Tiene un s&oacute;lo Veh&iacute;culo ?</h3>
          <p class="panel__paragraph">
            Puedes revisar la producci&oacute;n mensual de tu veh&iacute;culo, solicitando el acceso a la empresa
          </p>
          <button class="btn btn-transparent" id="sign-in-btn">
            UN VEH&Iacute;CULO
          </button>
        </div>
        <img class="panel__image" src="../assets/1.png" alt="" />
      </div>
    </div>
  </div>

</template>

<script>
  import InputRut from '../components/InputRut.vue'
  import swal from 'sweetalert'

  export default {
    components: {
      InputRut
    },
    name: 'login',
    data: () => ({
      loading: false,
      plate: '',
      password: '',
      snackbar: false,
      errorMessage: ''
    }),
    mounted () {
      const signInBtn = document.querySelector('#sign-in-btn')
      const signUpBtn = document.querySelector('#sign-up-btn')
      const container = document.querySelector('.change')

      signUpBtn.addEventListener('click', () => {
        container.classList.add('sign-up-mode')
      })

      signInBtn.addEventListener('click', () => {
        container.classList.remove('sign-up-mode')
      })
    },
    watch: {
      plate () {
        this.plate = this.plate.toUpperCase()
      }
    },
    methods: {
      login () {
        this.loading = true
        if (this.plate === '' || this.password === '') {
          swal('Error', 'Por favor llena todos los campos', 'error')
          this.loading = false
          return
        }
        this.$http.post('auth', {
          registrationPlate: this.plate,
          password: this.password
        }).then(res => {
          localStorage.setItem('token', res.body.token)
          localStorage.setItem('vehicleID', res.body.vehicleID)
          this.$root.$children[0].loading = true
          setTimeout(() => {
            this.$router.push('/reporte')
          }, 100)
        }).catch(res => {
          this.loading = false
          if (res.status === 403) {
            swal('Error', res.body.message, 'error')
            this.snackbar = true
          }
        })
      },
      loginFlota () {
        this.loading = true
        var rut = this.plate
        rut = rut.replace(/\./g, '').replace('-', '')
        if (rut === '' || this.password === '') {
          swal('Error', 'Por favor llena todos los campos', 'error')
          this.loading = false
          return
        }
        this.$http.post('auth-flota', {
          rut: rut,
          password: this.password
        }).then(res => {
          localStorage.setItem('tokenFlota', res.body.token)
          localStorage.setItem('ownerID', res.body.ownerID)
          this.$root.$children[0].loading = true
          setTimeout(() => {
            this.$router.push('/reporte-flota')
          }, 100)
        }).catch(res => {
          this.loading = false
          if (res.status === 403) {
            swal('Error', res.body.message, 'error')
            this.snackbar = true
          }
        })
      }
    },
    created () {
      if (localStorage.getItem('tokenFlota')) {
        this.$router.push('/reporte-flota')
      } else if (localStorage.getItem('token')) {
        this.$router.push('/reporte')
      }
    }
  }
</script>

<style lang="scss" scoped>
 * {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

a {
  text-decoration: none;
}

body, input {
  font-family: "Poppins", sans-serif;
}

.container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: #fff;
  overflow: hidden;
}

.container::before {
  content: "";
  position: absolute;
  width: 2000px;
  height: 2000px;
  border-radius: 50%;
  background: linear-gradient(-45deg, #4481eb, #4481eb);
  right: 48%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  z-index: 6;
  -webkit-transition: 1.8s ease-in-out;
  transition: 1.8s ease-in-out;
}

.container__forms {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.container__panels {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: -ms-grid;
  display: grid;
  -ms-grid-columns: (1fr) [2];
  grid-template-columns: repeat(2, 1fr);
}

form {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  padding: 0 5rem;
  overflow: hidden;
  -ms-grid-column: 1;
  -ms-grid-column-span: 1;
  grid-column: 1 / 2;
  -ms-grid-row: 1;
  -ms-grid-row-span: 1;
  grid-row: 1 / 2;
  -webkit-transition: 0.2s 0.7s ease-in-out;
  transition: 0.2s 0.7s ease-in-out;
}

form.form__sign-in {
  z-index: 2;
}

form.form__sign-up {
  z-index: 1;
  opacity: 0;
}

.form {
  position: absolute;
  top: 50%;
  left: 75%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 50%;
  display: -ms-grid;
  display: grid;
  -ms-grid-columns: 1fr;
  grid-template-columns: 1fr;
  z-index: 5;
  -webkit-transition: 1s 0.7s ease-in-out;
  transition: 1s 0.7s ease-in-out;
}

.form__title {
  font-size: 2.2rem;
  color: #444;
  margin-bottom: 10px;
  font-family: "Poppins", sans-serif !important;
}

.form__input-field {
  max-width: 380px;
  width: 100%;
  height: 3.437rem;
  background-color: #f0f0f0;
  margin: 10px 0;
  border-radius: 3.437rem;
  display: -ms-grid;
  display: grid;
  -ms-grid-columns: 15% 85%;
  grid-template-columns: 15% 85%;
  padding: 0 0.4rem;
}

.form__input-field i {
  text-align: center;
  line-height: 3.437rem;
  color: #acacac;
  font-size: 1.1rem;
}

.form__input-field input {
  background: none;
  outline: none;
  border: none;
  line-height: 1;
  font-weight: 600;
  font-size: 1.1rem;
  color: #333;
  border-radius: inherit;
}

.form__input-field input::-webkit-input-placeholder {
  color: #aaa;
  font-weight: 500;
}

.form__input-field input:-ms-input-placeholder {
  color: #aaa;
  font-weight: 500;
}

.form__input-field input::-ms-input-placeholder {
  color: #aaa;
  font-weight: 500;
}

.form__input-field input::placeholder {
  color: #aaa;
  font-weight: 500;
}

.form__submit {
  width: 9.375rem;
  height: 3.0625rem;
  border: none;
  outline: none;
  border-radius: 3.0625rem;
  cursor: pointer;
  background-color: #4481eb;
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
  margin: 10px 0;
  -webkit-transition: 0.5s;
  transition: 0.5s;
}

.form__submit:hover {
  background-color: #2d579e;
}

.form__social-text {
  padding: 0.7rem 0;
  font-size: 1rem;
}

.form__social-media {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.form__social-icons {
  height: 2.875rem;
  width: 2.875rem;
  border: 1px solid #333;
  border-radius: 50%;
  margin: 0 0.45rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  color: #333;
  font-size: 1.1rem;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}

.form__social-icons:hover {
  color: #4481eb;
  border-color: #4481eb;
}

.panel {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: end;
  -ms-flex-align: end;
  align-items: flex-end;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  text-align: center;
  z-index: 7;
}

.panel__content {
  color: #fff;
  -webkit-transition: 0.9s 0.6s ease-in-out;
  transition: 0.9s 0.6s ease-in-out;
}

.panel__left {
  pointer-events: all;
  padding: 3rem 17% 2rem 12%;
}

.panel__right {
  pointer-events: none;
  padding: 3rem 12% 2rem 17%;
}

.panel__title {
  font-weight: 600;
  line-height: 1;
  font-size: 1.5rem;
  font-family: "Poppins", sans-serif;
}

.panel__paragraph {
  font-size: 0.95rem;
  padding: 0.7rem 0;
  max-width: 560px;
}

.panel__image {
  width: 100%;
  -webkit-transition: 1.1s 0.4s ease-in-out;
  transition: 1.1s 0.4s ease-in-out;
}

.btn {
  border: none;
  outline: none;
  border-radius: 3.0625rem;
  cursor: pointer;
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
  -webkit-transition: 0.5s;
  transition: 0.5s;
  margin: 0;
  background: none;
  border: 2px solid #fff;
  width: 130px;
  height: 41px;
  font-size: 0.8rem;
}

/*Animation*/
.panel__right .panel__content,
.panel__right .panel__image {
  -webkit-transform: translateX(800px);
  transform: translateX(800px);
}

.container.sign-up-mode .panel__right .panel__content,
.container.sign-up-mode .panel__right .panel__image {
  -webkit-transform: translateX(0px);
  transform: translateX(0px);
}

.container.sign-up-mode::before {
  -webkit-transform: translate(100%, -50%);
  transform: translate(100%, -50%);
  right: 52%;
}

.container.sign-up-mode .panel__left .panel__image,
.container.sign-up-mode .panel__left .panel__content {
  -webkit-transform: translateX(-800px);
  transform: translateX(-800px);
}

.container.sign-up-mode .panel__left {
  pointer-events: none;
}

.container.sign-up-mode .panel__right {
  pointer-events: all;
}

.container.sign-up-mode .form {
  left: 25%;
}

.container.sign-up-mode form.form__sign-in {
  z-index: 1;
  opacity: 0;
}

.container.sign-up-mode form.form__sign-up {
  z-index: 2;
  opacity: 1;
}

@media (max-width: 870px) {
  .container {
    min-height: 800px;
    height: 100vh;
  }
  .container::before {
    width: 1500px;
    height: 1500px;
    left: 30%;
    bottom: 68%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    right: initial;
    top: initial;
    -webkit-transition: 2s ease-in-out;
    transition: 2s ease-in-out;
  }
  .form {
    width: 100%;
    left: 50%;
    top: 95%;
    -webkit-transform: translate(-50%, -100%);
    transform: translate(-50%, -100%);
    -webkit-transition: 1s 0.8s ease-in-out;
    transition: 1s 0.8s ease-in-out;
  }
  .container__panels {
    -ms-grid-columns: 1fr;
    grid-template-columns: 1fr;
    -ms-grid-rows: 1fr 2fr 1fr;
    grid-template-rows: 1fr 2fr 1fr;
  }
  .panel {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 2.5rem 8%;
  }
  .panel__left {
    -ms-grid-row: 1;
    -ms-grid-row-span: 1;
    grid-row: 1 / 2;
  }
  .panel__right {
    -ms-grid-row: 3;
    -ms-grid-row-span: 1;
    grid-row: 3 / 4;
  }
  .panel__image {
    width: 200px;
    -webkit-transition: 0.9s 0.6s ease-in-out;
    transition: 0.9s 0.6s ease-in-out;
  }
  .panel__content {
    padding-right: 15%;
    -webkit-transition: 0.9s 0.8s ease-in-out;
    transition: 0.9s 0.8s ease-in-out;
  }
  .panel__title {
    font-size: 1.2rem;
  }
  .panel__paragraph {
    font-size: 0.7rem;
    padding: 0.5rem 0;
  }
  .panel__right .panel__content,
  .panel__right .panel__image {
    -webkit-transform: translateY(300px);
    transform: translateY(300px);
  }
  .btn {
    width: 6.875rem;
    height: 2.187rem;
    font-size: 0.7rem;
  }
  .container.sign-up-mode::before {
    -webkit-transform: translate(-50%, 100%);
    transform: translate(-50%, 100%);
    bottom: 32%;
    right: initial;
  }
  .container.container.sign-up-mode .panel__left .panel__image,
  .container.container.sign-up-mode .panel__left .panel__content {
    -webkit-transform: translateY(-300px);
    transform: translateY(-300px);
  }
  .container.sign-up-mode .form {
    top: 5%;
    -webkit-transform: translate(-50%, 0);
    transform: translate(-50%, 0);
    left: 50%;
  }
}

@media (max-width: 570px) {
  form {
    padding: 0 1.5rem;
  }
  .panel__image {
    display: none;
  }
  .panel__content {
    padding: 0.5rem 1rem;
  }
  .container::before {
    bottom: 72%;
    left: 50%;
  }
  .container.sign-up-mode::before {
    bottom: 28%;
    left: 50%;
  }
}

.container {
  max-width: inherit !important;
}

</style>



// WEBPACK FOOTER //
// src/pages/login.vue